import { getEnvVars } from '@order/utils';

/**
 * Adds the AWS WAF script to the head of the document.
 */
export const addAwsWafScript = () => {
  if (!AWS_WAF_CHALLENGE_URL || document.querySelector(`script[id="${AWS_WAF_SCRIPT_ID}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.id = AWS_WAF_SCRIPT_ID;
  script.type = 'text/javascript';
  script.src = AWS_WAF_CHALLENGE_URL;
  script.defer = true;

  document.head.appendChild(script);
};

// ─── Constants ───────────────────────────────────────────────────────────────

const AWS_WAF_SCRIPT_ID = 'aws-waf-challenge-script';
const AWS_WAF_CHALLENGE_URL = getEnvVars().AWS_WAF_CHALLENGE_URL;
